// extracted by mini-css-extract-plugin
export default {"container":"ParseDataFieldWrapper_container__5KBlH","icon":"ParseDataFieldWrapper_icon__8VO46"};